// extracted by mini-css-extract-plugin
export default {"v-pebble":"var(--pebble)","v-white":"var(--white)","appliedFiltersCount":"results_list__appliedFiltersCount__USQHL"};